export const API_BASE_URL = 'https://api.townride.slotinsolutions.com/api';

export const ENDPOINTS = {
  SETTINGS: '/settings/',
  SEND_OTP: '/users/customer/auth/send-otp/',
  VERIFY_OTP: '/users/customer/auth/verify-otp/',
  FIREBASE_TOKEN: '/users/firebase-token/',
  UPDATE_PROFILE: '/users/profile/update/'
};
